import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthInit } from '@/hooks/useAuth';
import { TooltipProvider } from '@/features/tooltips/TooltipContext';
import { router } from '@/routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/** Runs auth initialization (session check or dev bypass) */
function AuthInit() {
  useAuthInit();
  return null;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthInit />
      <TooltipProvider>
        <RouterProvider router={router} />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
